import { WasteKind } from "generated-graphql/graphql";

/** Reader-facing names for the four management programs. */
export function prettyPrintWasteKind(kind: WasteKind): string {
  switch (kind) {
    case WasteKind.Rcra:
      return "Ordinary hazardous waste";
    case WasteKind.UniversalWaste:
      return "Universal waste";
    case WasteKind.UsedOil:
      return "Used oil";
    case WasteKind.Pharmaceutical:
      return "Pharmaceutical";
  }
}
